import { CarouselArrowNext } from './CarouselArrowNext';
import { CarouselArrowPrev } from './CarouselArrowPrev';
import { CarouselPagination } from './CarouselPagination';
import { CarouselSlider } from './CarouselSlider';
import { Carousel as CarouselComponent } from './Carousel';
var Carousel = CarouselComponent;
Carousel.Slider = CarouselSlider;
Carousel.ArrowNext = CarouselArrowNext;
Carousel.ArrowPrev = CarouselArrowPrev;
Carousel.Pagination = CarouselPagination;
export { Carousel };